@for (filter of filters; track filter) {
  @if (animal?.category?.toLowerCase() === filter.id.toLowerCase()) {
    <div class="flex flex-col gap-1 items-center justify-center category-icon m-1 p-4 rounded-lg
    inset-shadow-sm inset-shadow-[#a5a5a5]
    w-[84px] h-[84px] max-w-[84px] max-h-[84px]">
      <img alt="category" [src]="filter.imgSrc" class="w-auto h-[30px]"/>
      <p class="text-sm font-semibold">{{ filter.title }}</p>
    </div>
  }
}
